const METERS_PER_NAUTICAL_MILE = 1852

export const nauticalMilesToMeters = (nauticalMiles: number) =>
  nauticalMiles * METERS_PER_NAUTICAL_MILE
